import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import frES from './locales/fr-es.json';
import nlBAO from './locales/nl-bao.json';
import nlVo from './locales/nl-vo.json';
import nlSo from './locales/nl-so.json';

export const resources = {
  nl: {
    fallback: nlSo,
    SO: nlSo,
    BAO: nlBAO,
    VO: nlVo,
  },
  fr: {
    fallback: frES,
    ES: frES,
  },
} as const;

export type Language = keyof typeof resources;

i18n.use(initReactI18next).init({
  resources,
  lng: process.env.REACT_APP_P_STUDIO_LANGUAGE,
  defaultNS: process.env.REACT_APP_P_STUDIO_GROUP,
  fallbackNS: 'fallback',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: process.env.NODE_ENV !== 'test',
  },
});

export default i18n;
